// PROD
export const base_url = "https://htprdapi.hightable.ai";
export const razorpay_key = "rzp_live_g7ZPoD35smdm8e";

// Local
// export const base_url = "http://localhost:1337";
// export const razorpay_key = "rzp_test_PMTVQEuDsr7kbS";

